import React, { useContext, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import style from "./index.module.scss";
import { message } from "antd";
import { rootContext } from "@/context/rootContext";
import { Spin } from "antd";
import Api from "@/common/Api/accountManage";
import { blacklistedTip, defaultErrorMessage } from "@/common/utils";

const RegEmail = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

function LoginBox() {
  const [pwdLogin, setPwdLogin] = useState(true);
  const changeEven = () => {
    setPwdLogin(!pwdLogin);
  };
  return (pwdLogin ? <PwdLogin change={changeEven} /> : <CodeLogin change={changeEven} />);
}

function PwdLogin (props) {
  const navigate = useNavigate();
  const { setLogionStatus, setDialogIndex } = useContext(rootContext);
  const [showPwd, setShowPwd] = useState(false);
  const [showLoad, setShowLoad] = useState(false);

  const emailRef = useRef();
  const pwdRef = useRef();

  const pwdLogin = async () => {
    const email = emailRef.current.value.trim();
    const pwd = pwdRef.current.value.trim();
    if (!email.length || !RegEmail.test(email)) {
      message.error("Please enter a valid email address");
      return;
    }
    if (!pwd || !pwd.length) {
      message.error("Login missing verification code or password");
      return;
    }
    setShowLoad(true);
    const res = await Api.fl84Login({ email, password: pwd });
    setShowLoad(false);
    if (res.status === 200) {
      // 登录成功
      // 推送至commEnter监听
      setLogionStatus(res.data);
      window.gtag("event", "pc_fl84_login");
    } else {
      if (+res.data.code === 400234) {
        blacklistedTip(res.data.message);
      } else {
        defaultErrorMessage(res, "fl84Login");
      }
    }

  };

  const keyDown1 = (e) => {
    if (e.keyCode === 13) { pwdLogin(); }
  };

  return (
    <div className={style.loginContent}>
      <p className={style.loginTitle}>LOG IN</p>
      <input type="text" placeholder="Enter Your Email" ref={emailRef}></input>
      <div className={style.passwordItem}>
        <input onKeyDown={(e) => keyDown1(e)} type={showPwd ? "text" : "password"} placeholder="Password" ref={pwdRef}></input>
        <div className={`${style.hideIcon} ${showPwd ? style.active : ""}`} onClick={() => { setShowPwd(!showPwd); }}></div>
      </div>
      <div className={style.other}>
        <a className={style.fp} onClick={() => { setDialogIndex(2); }}>Forgot Password?</a>
        <a className={style.eql} onClick={props.change}>Email quick login</a>
      </div>
      <a className={style.loginBtn} onClick={pwdLogin}>LOG IN</a>
      <p className={style.sign}>Don’ t have an account？<a onClick={() => { navigate("/signup"); }}>Sign Up</a></p>
      {
        showLoad && (
          <div className={style.loading}>
            <Spin size="large" />
          </div>
        )
      }
    </div>
  );
}

function CodeLogin (props) {
  const navigate = useNavigate();
  const { setLogionStatus } = useContext(rootContext);
  const [showLoad, setShowLoad] = useState(false);
  const [isSengCode, setISSengCode] = useState(false);
  const [countDown, setCountDown] = useState(59);

  const emailRef = useRef();
  const pwdRef = useRef();

  const codeLogin = async () => {
    const email = emailRef.current.value.trim();
    const mailVerifyCode = pwdRef.current.value.trim();
    if (!email.length || !RegEmail.test(email)) {
      message.error("Please enter a valid email address");
      return;
    }
    if (!mailVerifyCode || !mailVerifyCode.length) {
      message.error("Login missing verification code or password");
      return;
    }
    setShowLoad(true);
    const res = await Api.fl84Login({ email, mailVerifyCode });
    setShowLoad(false);
    if (res.status === 200) {
      // 登录成功
      // 推送至commEnter监听
      setLogionStatus(res.data);
      window.gtag("event", "pc_fl84_login");
    } else {
      if (+res.data.code === 400234) {
        blacklistedTip(res.data.message);
      } else {
        defaultErrorMessage(res, "fl84Login");
      }
    }

  };

  const keyDown1 = (e) => {
    if (e.keyCode === 13) { codeLogin(); }
  };

  const loopCountDown = (num) => {
    if (num > 0) {
      setCountDown(num - 1);
      setTimeout(() => loopCountDown(num - 1), 1000);
    } else {
      setISSengCode(false);
    }
  };

  const sendVerCode = async () => {
    if (isSengCode) {
      return;
    }
    const email = emailRef.current.value.trim();
    if (!email.length || !RegEmail.test(email)) {
      message.error("Please enter a valid email address");
      return;
    }
    setShowLoad(true);
    const res = await Api.sendMailVerifyCode({ email });
    setShowLoad(false);
    if (!res || res.status !== 200) {
      defaultErrorMessage(res, "fl84Login");
    } else {
      setISSengCode(true);
      setCountDown(59);
      setTimeout(() => loopCountDown(59), 1000);
    }
  };

  return (
    <div className={style.loginContent}>
      <p className={style.loginTitle}>LOG IN</p>
      <div className={style.back} onClick={props.change}></div>
      <input type="text" placeholder="Enter Your Email" ref={emailRef}></input>
      <div className={style.codeItem}>
        <input onKeyDown={(e) => keyDown1(e)} type="text" placeholder="Enter 6--digit code" ref={pwdRef}></input>
        {
          isSengCode ? (
            <div className={style.timeLoad}>
              <p>{countDown}S</p>
            </div>
          ) : (
            <div className={style.codeBtn} onClick={sendVerCode}>
              <p>SEND CODE</p>
            </div>
          )
        }
      </div>
      <a className={style.loginBtn} onClick={codeLogin}>LOG IN</a>
      <p className={style.sign}>Don’ t have an account？<a onClick={() => { navigate("/signup"); }}>Sign Up</a></p>
      {
        showLoad && (
          <div className={style.loading}>
            <Spin size="large" />
          </div>
        )
      }
    </div>
  );
}

export default LoginBox;
